export default __webpack_public_path__ + "static/media/acct-pay-card.189b8529.png";